import { render, staticRenderFns } from "./SearchArticleModel.vue?vue&type=template&id=45e4d6fb&scoped=true"
import script from "./SearchArticleModel.vue?vue&type=script&lang=js"
export * from "./SearchArticleModel.vue?vue&type=script&lang=js"
import style0 from "./SearchArticleModel.vue?vue&type=style&index=0&id=45e4d6fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e4d6fb",
  null
  
)

export default component.exports